// Restyle appearance preference is independent of upstream IRC settings.
const media = window.matchMedia("(prefers-color-scheme: dark)");
let preference = "system";
try {
	let saved = localStorage.getItem("gamja_theme");
	if (["light", "dark", "system"].includes(saved)) {
		preference = saved;
	}
} catch (_err) {
	// Appearance remains usable when storage is unavailable.
}

function applyTheme() {
	document.documentElement.dataset.theme = preference === "system"
		? (media.matches ? "dark" : "light") : preference;
}

export function getTheme() {
	return preference;
}

export function setTheme(value) {
	if (!["light", "dark", "system"].includes(value)) {
		return;
	}
	preference = value;
	try {
		localStorage.setItem("gamja_theme", value);
	} catch (_err) {
		// Use the selected appearance for this session.
	}
	applyTheme();
}

media.addEventListener("change", applyTheme);
applyTheme();
